<div class="point-extraction-table">
  <app-main-table [tableConfig]="tableConfig" class="point-extraction-table"></app-main-table>
</div>